export const TOP_NAVBAR_MOBILE_HEIGHT = 56;
export const MEDIUM_DEVICE_MAX_WIDTH = 1279;
export const SMALL_MEDIUM_DEVICE_MAX_WIDTH = 959;
export const EXTRA_SMALL_DEVICE_MAX_WIDTH = 599;
// ID of the hero section element - usage: changing navbar styles based on the hero section position on screen
export const HERO_SECTION_ID = 'hero-section';

export const links = [
    {
        to: '/',
        name: 'Home'
    },
    {
        to: '/resources',
        name: 'Resources'
    },
    {
        to: '/pricing',
        name: 'Pricing'
    },
    {
        to: '/contact',
        name: 'Contact'
    },
    {
        to: '/about-us',
        name: 'About Us'
    }
];

export const getBreadCrumbsFromPath = (path: string): string[] => {
    return path.split('/').filter(segment => segment);
};

export const isEmailValid = (email: string) => {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
};

export const scrollToElementByAnchor = (anchor: string) => {
    const id = anchor.substring(1);
    const el = document.getElementById(id);
    if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
    }
};

export const centsToEurosString = (cents: number) => {
    if (cents === 0) {
        return 'Free';
    }
    return '€' + Math.ceil(cents / 100);
};

export const MuiTreeItemStyle = {
    '& .MuiTreeItem-content': {
        width: 'unset',
        color: '#373737'
    },
    '& .MuiTreeItem-content:hover': {
        color: '#006bb2ed',
        backgroundColor: 'transparent'
    },
    '& .MuiTreeItem-content.Mui-selected': {
        backgroundColor: 'transparent'
    },
    '& .MuiTreeItem-content.Mui-selected.Mui-focused': {
        backgroundColor: 'transparent'
    },
    '& .MuiTreeItem-content .MuiTreeItem-label': {
        fontSize: '15px',
        paddingTop: '4px',
        paddingBottom: '4px'
    },
    a: {
        color: '#373737',
        textDecoration: 'none'
    },
    'a:hover': {
        color: '#006bb2ed'
    }
};

export const MuiSelectStyle = {
    '& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input': {
        paddingTop: '11.5px',
        paddingBottom: '11.5px',
        backgroundColor: '#F2F8FF'
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#F2F8FF'
    }
};
